export default __webpack_public_path__ + "static/media/photo02_sp.9867516d.jpg";